import styled from 'styled-components'

export const StyledMapLeaflet = styled.div`
    .leaflet-container{
        width: 100%;
        height: 30vh;
    }
`